<af-full-table class="w-100 h-100"
               [filterFields]="filterFields"
               [filterEvent]="tableEvent?.filter"
               (tableUpdateListener)="loadFaqs($event)"
               [dataSource]="dataSource"
               [totalElements]="totalElements"
               [showImport]="false"
               [showExport]="false"
               emptyStateIconName="ic_empty_state_no_docs"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleFaqNotCreated"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleFaqNotCreated"
               emptyStateButtonLabel="i18n_af_buttonAddFaqQuestion"
               (emptyStateClickListener)="addQuestionClickListener.emit()"
               totalElementsTranslationKey="i18n_af_labelTotalElementsFaq"
               placeholderContext="faq"/>
